// AwardsCard — main column list of accolades. Hides when empty.
//
// Each row shows the award name + an optional meta line of season +
// source. Trophy glyph on the left of each row keeps the visual rhythm.

import { Trophy } from 'lucide-react'

interface Award {
  id: string
  award_name: string
  season: string | null
  source: string | null
  awarded_at: string | null
}

export default function AwardsCard({ awards }: { awards: Award[] }) {
  if (awards.length === 0) return null

  return (
    <section className="bg-hoop-surface border border-hoop-border rounded-2xl p-5">
      <header className="flex items-center gap-2 mb-3">
        <Trophy className="w-3.5 h-3.5 text-hoop-amber" />
        <h2 className="text-[12px] font-bold uppercase tracking-wider text-hoop-accent">
          Awards
        </h2>
        <span className="text-[11px] text-hoop-text-3 font-normal normal-case tracking-normal">
          · {awards.length}
        </span>
      </header>

      <ul className="space-y-2">
        {awards.map((a) => {
          const meta = [a.season, a.source].filter(Boolean).join(' · ')
          return (
            <li
              key={a.id}
              className="flex items-start gap-3 p-2 rounded-md hover:bg-hoop-bg"
            >
              <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-hoop-amber-bg text-hoop-amber flex-shrink-0">
                <Trophy className="w-3.5 h-3.5" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-hoop-text">
                  {a.award_name}
                </div>
                {meta && (
                  <div className="text-xs text-hoop-text-3">
                    {meta}
                  </div>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
